import React, { useState, useEffect, useRef, useMemo } from 'react';

const TimeOnPageTracker = ({ onTimeSpent }) => {
    const [startTime, setStartTime] = useState(null);
    const [duration, setDuration] = useState(0); // In seconds
    const intervalRef = useRef(null); // To store the interval ID for cleanup
    const longIntervalRef = useRef(null); // To store the long interval ID for cleanup

    const identifier = useMemo(() => {
        return crypto.randomUUID();
    }, [window.location.pathname]);

    // Effect 1: Initialize timer and handle component unmount
    useEffect(() => {
        // Record the initial start time when the component mounts
        const initialStartTime = Date.now();
        setStartTime(initialStartTime);
        // console.log('Page entered at:', new Date(initialStartTime).toLocaleTimeString());

        // Start an interval to update the duration every second
        intervalRef.current = setInterval(() => {
            const duration = Math.floor((Date.now() - initialStartTime) / 1000);
            setDuration(duration);
        }, 1000);

        longIntervalRef.current = setInterval(() => {
            const duration = Math.floor((Date.now() - initialStartTime) / 1000);
            onTimeSpent(duration, identifier);
        }, 30000);

        // Cleanup function: This runs when the component unmounts (user leaves the page)
        return () => {
            clearInterval(intervalRef.current); // Clear the interval to prevent memory leaks
            clearInterval(longIntervalRef.current); // Clear the long interval to prevent memory leaks
            const endTime = Date.now();
            const finalDuration = Math.floor((endTime - initialStartTime) / 1000); // Calculate final duration in seconds
            // console.log('Page left at:', new Date(endTime).toLocaleTimeString());
            // console.log('Total time spent on page:', finalDuration, 'seconds');

            // Call the onTimeSpent prop to send the final duration to the parent
            if (onTimeSpent && typeof onTimeSpent === 'function') {
                onTimeSpent(finalDuration, identifier);
            }
        };
    }, [onTimeSpent]); // `onTimeSpent` is a dependency to ensure the cleanup function gets the latest version if it ever changes (though usually it's stable)

    // Effect 2: Handle page visibility changes (tab switching, minimizing)
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // User switched tab or minimized browser - pause the timer
                // console.log('User is inactive (tab hidden)');
                clearInterval(intervalRef.current);
            } else {
                // User returned to the tab - resume the timer
                // console.log('User is active (tab visible)');
                if (startTime) { // Ensure startTime is set from the first effect
                    // Adjust startTime to ensure continuous duration calculation
                    // We set startTime to what it *should have been* to get the current duration
                    setStartTime(Date.now() - (duration * 1000));
                    // Restart the interval
                    intervalRef.current = setInterval(() => {
                        setDuration(Math.floor((Date.now() - startTime) / 1000));
                    }, 1000);
                }
            }
        };

        // Add event listener for visibility changes
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup for this effect: remove the event listener
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [startTime, duration]); // Dependencies for this effect

    // Helper to format the duration into a human-readable string
    const formatDuration = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${hours > 0 ? `${hours}h ` : ''}${minutes > 0 ? `${minutes}m ` : ''}${seconds}s`;
    };

    return (
        <div></div>
        // <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
        //   <h3>⏱️ Time Tracker</h3>
        //   <p>Time spent on this page: <strong>{formatDuration(duration)}</strong></p>
        //   <p style={{ fontSize: '0.8em', color: '#666' }}>
        //     (This timer updates live. The final time is logged when you leave or close this tab.)
        //   </p>
        // </div>
    );
};

export default TimeOnPageTracker;